module.exports = __webpack_public_path__ + "static/img/messenger-button-v22.65d167f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/salepage/btn_social/messenger-button-v22.jpg
// module id = nWPZ
// module chunks = 134